import React, { useState, useEffect } from "react";
import "./CreateCampaign.css";
import axios from "axios";

const SESSION_KEY = "audience_content_form";

const AudienceContent = ({ onNext, onBack }) => {
  // Campaign Goal selection
  const [selectedGoal, setSelectedGoal] = useState("brand-awareness");

  // Influencer Selection Priority
  const [selectedPriority, setSelectedPriority] =
    useState("reach-optimization");

  // Campaign Management
  const [selectedManagement, setSelectedManagement] = useState("ai-automation");

  // Video Requirement - 默认展开
  const [videoRequirementOpen, setVideoRequirementOpen] = useState(true);
  const [videoInput, setVideoInput] = useState("");
  const [videoRequirements, setVideoRequirements] = useState([]);

  // Target Audience expandable state
  const [targetAudienceOpen, setTargetAudienceOpen] = useState(true);

  // Age range selection
  const [ageRangeType, setAgeRangeType] = useState("ai-optimized");
  const [selectedAgeGroups, setSelectedAgeGroups] = useState([]);

  // Gender selection
  const [genderType, setGenderType] = useState("ai-optimized");
  const [selectedGenders, setSelectedGenders] = useState([]);

  // Avg video impression selection
  const [avgVideoImpressionType, setAvgVideoImpressionType] = useState("ai-optimized");

  // Follower range selection
  const [followerRangeType, setFollowerRangeType] = useState("ai-optimized");

  // Form inputs
  const [campaignLanguageInput, setCampaignLanguageInput] = useState("");
  const [selectedLanguages, setSelectedLanguages] = useState([]);
  const [audienceInterestsInput, setAudienceInterestsInput] = useState("");
  const [selectedInterests, setSelectedInterests] = useState([]);
  const [generatedInterests, setGeneratedInterests] = useState([]);

  const [audienceRegionInput, setAudienceRegionInput] = useState("");
  const [selectedRegions, setSelectedRegions] = useState([]);
  const [regionSearchOpen, setRegionSearchOpen] = useState(false);
  const [filteredRegions, setFilteredRegions] = useState([]);

  const [audienceCommunityType, setAudienceCommunityType] =
    useState("ai-optimized");
  const [audienceCommunityInput, setAudienceCommunityInput] = useState("");
  const [selectedCommunities, setSelectedCommunities] = useState([]);

  const [audienceIndustryType, setAudienceIndustryType] =
    useState("ai-optimized");
  const [audienceIndustryInput, setAudienceIndustryInput] = useState("");
  const [selectedIndustries, setSelectedIndustries] = useState([]);

  const [requirementInput, setRequirementInput] = useState("");
  const [selectedRequirements, setSelectedRequirements] = useState([]);

  const [customAvgVideoImpression, setCustomAvgVideoImpression] = useState("");
  const [customFollowerMin, setCustomFollowerMin] = useState("");
  const [customFollowerMax, setCustomFollowerMax] = useState("");

  const [tagsLoading, setTagsLoading] = useState(false);

  // 输入验证函数
  const validatePositiveInteger = (value) => {
    const num = parseInt(value, 10);
    return !isNaN(num) && num > 0 && num.toString() === value;
  };

  const handleAvgVideoImpressionChange = (e) => {
    const value = e.target.value;
    if (value === "" || validatePositiveInteger(value)) {
      setCustomAvgVideoImpression(value);
    } else {
      alert("请输入一个正整数");
    }
  };

  const handleFollowerMinChange = (e) => {
    const value = e.target.value;
    if (value === "" || validatePositiveInteger(value)) {
      setCustomFollowerMin(value);
    } else {
      alert("请输入一个正整数");
    }
  };

  const handleFollowerMaxChange = (e) => {
    const value = e.target.value;
    if (value === "" || validatePositiveInteger(value)) {
      setCustomFollowerMax(value);
    } else {
      alert("请输入一个正整数");
    }
  };

  // Countries/Regions database with population data (in millions)
  const availableRegions = [
    // 北美洲
    { name: "United States", code: "US", continent: "North America", population: 331.9 },
    { name: "Canada", code: "CA", continent: "North America", population: 38.3 },
    { name: "Mexico", code: "MX", continent: "North America", population: 128.9 },
    
    // 欧洲
    { name: "United Kingdom", code: "GB", continent: "Europe", population: 67.5 },
    { name: "Germany", code: "DE", continent: "Europe", population: 83.2 },
    { name: "France", code: "FR", continent: "Europe", population: 68.0 },
    { name: "Italy", code: "IT", continent: "Europe", population: 59.1 },
    { name: "Spain", code: "ES", continent: "Europe", population: 47.4 },
    { name: "Netherlands", code: "NL", continent: "Europe", population: 17.4 },
    { name: "Sweden", code: "SE", continent: "Europe", population: 10.4 },
    { name: "Norway", code: "NO", continent: "Europe", population: 5.4 },
    { name: "Denmark", code: "DK", continent: "Europe", population: 5.8 },
    { name: "Finland", code: "FI", continent: "Europe", population: 5.5 },
    { name: "Switzerland", code: "CH", continent: "Europe", population: 8.7 },
    { name: "Austria", code: "AT", continent: "Europe", population: 9.0 },
    { name: "Belgium", code: "BE", continent: "Europe", population: 11.6 },
    { name: "Portugal", code: "PT", continent: "Europe", population: 10.3 },
    { name: "Ireland", code: "IE", continent: "Europe", population: 5.0 },
    { name: "Poland", code: "PL", continent: "Europe", population: 37.9 },
    { name: "Czech Republic", code: "CZ", continent: "Europe", population: 10.7 },
    { name: "Hungary", code: "HU", continent: "Europe", population: 9.7 },
    { name: "Greece", code: "GR", continent: "Europe", population: 10.7 },
    { name: "Russia", code: "RU", continent: "Europe", population: 144.1 },
    
    // 亚洲
    { name: "China", code: "CN", continent: "Asia", population: 1412.0 },
    { name: "Japan", code: "JP", continent: "Asia", population: 125.8 },
    { name: "South Korea", code: "KR", continent: "Asia", population: 51.8 },
    { name: "India", code: "IN", continent: "Asia", population: 1380.0 },
    { name: "Singapore", code: "SG", continent: "Asia", population: 5.9 },
    { name: "Hong Kong", code: "HK", continent: "Asia", population: 7.5 },
    { name: "Taiwan", code: "TW", continent: "Asia", population: 23.6 },
    { name: "Thailand", code: "TH", continent: "Asia", population: 69.8 },
    { name: "Malaysia", code: "MY", continent: "Asia", population: 32.7 },
    { name: "Indonesia", code: "ID", continent: "Asia", population: 273.5 },
    { name: "Philippines", code: "PH", continent: "Asia", population: 109.0 },
    { name: "Vietnam", code: "VN", continent: "Asia", population: 97.3 },
    { name: "UAE", code: "AE", continent: "Asia", population: 9.9 },
    { name: "Saudi Arabia", code: "SA", continent: "Asia", population: 34.8 },
    { name: "Israel", code: "IL", continent: "Asia", population: 9.4 },
    
    // 大洋洲
    { name: "Australia", code: "AU", continent: "Oceania", population: 25.7 },
    { name: "New Zealand", code: "NZ", continent: "Oceania", population: 5.1 },
    
    // 南美洲
    { name: "Brazil", code: "BR", continent: "South America", population: 215.3 },
    { name: "Argentina", code: "AR", continent: "South America", population: 45.4 },
    { name: "Chile", code: "CL", continent: "South America", population: 19.1 },
    { name: "Colombia", code: "CO", continent: "South America", population: 50.9 },
    { name: "Peru", code: "PE", continent: "South America", population: 33.0 },
    { name: "Uruguay", code: "UY", continent: "South America", population: 3.5 },
    
    // 非洲
    { name: "South Africa", code: "ZA", continent: "Africa", population: 60.4 },
    { name: "Nigeria", code: "NG", continent: "Africa", population: 218.5 },
    { name: "Kenya", code: "KE", continent: "Africa", population: 54.0 },
    { name: "Egypt", code: "EG", continent: "Africa", population: 104.3 },
    { name: "Morocco", code: "MA", continent: "Africa", population: 37.5 }
  ];

  // Age groups options
  const ageGroupOptions = [
    "13-17",
    "18-24",
    "25-34",
    "35-44",
    "45-54",
    "55-64",
    "65+",
  ];

  // Gender options
  const genderOptions = ["Male", "Female"];

  // Video requirement templates
  const videoTemplates = [
    {
      name: "Product Demo",
      description: "Showcase product features and benefits",
      requirements: [
        "Include clear product demonstration",
        "Highlight key features and benefits",
        "Show product in use",
        "Display product packaging",
      ],
    },
    {
      name: "Lifestyle Content",
      description: "Show product in real-life scenarios",
      requirements: [
        "Show product in daily life",
        "Include authentic user experience",
        "Feature relatable scenarios",
        "Demonstrate practical benefits",
      ],
    },
    {
      name: "How-to Tutorial",
      description: "Step-by-step product usage guide",
      requirements: [
        "Clear step-by-step instructions",
        "Show proper product usage",
        "Include tips and tricks",
        "Demonstrate common use cases",
      ],
    },
    {
      name: "Product Review",
      description: "Honest product evaluation",
      requirements: [
        "Share honest opinions",
        "Compare with similar products",
        "Discuss pros and cons",
        "Provide final recommendation",
      ],
    },
  ];

  // Redlines/Blacklists options
  const redlineOptions = [
    "No controversial or political content",
    "No explicit or inappropriate content",
    "No competitors' products in content",
    "No negative brand mentions",
    "No fake or misleading content",
    "No hate speech or discriminatory content",
    "No illegal activities or substances",
    "No copyright infringement",
  ];

  // Creator Preferences options
  const preferencesOptions = [
    "Clean content history",
    "No brand conflicts",
    "Professional online presence",
    "Positive brand associations",
    "Trusted by other brands",
    "Consistent brand voice",
    "High-quality content standards",
    "Authentic audience engagement",
  ];

  // 恢复
  useEffect(() => {
    const saved = sessionStorage.getItem(SESSION_KEY);
    if (saved) {
      try {
        const data = JSON.parse(saved);
        if (data.selectedGoal) setSelectedGoal(data.selectedGoal);
        if (data.selectedPriority) setSelectedPriority(data.selectedPriority);
        if (data.selectedManagement) setSelectedManagement(data.selectedManagement);
        if (Array.isArray(data.videoRequirements)) setVideoRequirements(data.videoRequirements);
        if (data.ageRangeType) setAgeRangeType(data.ageRangeType);
        if (Array.isArray(data.selectedAgeGroups)) setSelectedAgeGroups(data.selectedAgeGroups);
        if (data.genderType) setGenderType(data.genderType);
        if (Array.isArray(data.selectedGenders)) setSelectedGenders(data.selectedGenders);
        if (data.avgVideoImpressionType) setAvgVideoImpressionType(data.avgVideoImpressionType);
        if (typeof data.customAvgVideoImpression === 'string') setCustomAvgVideoImpression(data.customAvgVideoImpression);
        if (data.followerRangeType) setFollowerRangeType(data.followerRangeType);
        if (typeof data.customFollowerMin === 'string') setCustomFollowerMin(data.customFollowerMin);
        if (typeof data.customFollowerMax === 'string') setCustomFollowerMax(data.customFollowerMax);
        if (Array.isArray(data.selectedLanguages)) setSelectedLanguages(data.selectedLanguages);
        if (Array.isArray(data.selectedInterests)) setSelectedInterests(data.selectedInterests);
        if (Array.isArray(data.selectedRegions)) setSelectedRegions(data.selectedRegions);
        if (data.audienceCommunityType) setAudienceCommunityType(data.audienceCommunityType);
        if (Array.isArray(data.selectedCommunities)) setSelectedCommunities(data.selectedCommunities);
        if (data.audienceIndustryType) setAudienceIndustryType(data.audienceIndustryType);
        if (Array.isArray(data.selectedIndustries)) setSelectedIndustries(data.selectedIndustries);
        if (Array.isArray(data.selectedRequirements)) setSelectedRequirements(data.selectedRequirements);
        if (Array.isArray(data.generatedInterests)) setGeneratedInterests(data.generatedInterests);
      } catch {}
    }
  }, []);

  // 持久化
  useEffect(() => {
    const totalPopulation = calculateTotalPopulation();
    sessionStorage.setItem(
      SESSION_KEY,
      JSON.stringify({
        selectedGoal,
        selectedPriority,
        selectedManagement,
        videoRequirements,
        ageRangeType,
        selectedAgeGroups,
        genderType,
        selectedGenders,
        avgVideoImpressionType,
        customAvgVideoImpression,
        followerRangeType,
        customFollowerMin,
        customFollowerMax,
        selectedLanguages,
        selectedInterests,
        selectedRegions,
        audienceCommunityType,
        selectedCommunities,
        audienceIndustryType,
        selectedIndustries,
        selectedRequirements,
        generatedInterests,
        // 添加人口数据（绝对数字）
        audiencePopulation: Math.round(totalPopulation * 1000000)
      })
    );
  }, [
    selectedGoal,
    selectedPriority,
    selectedManagement,
    videoRequirements,
    ageRangeType,
    selectedAgeGroups,
    genderType,
    selectedGenders,
    avgVideoImpressionType,
    customAvgVideoImpression,
    followerRangeType,
    customFollowerMin,
    customFollowerMax,
    selectedLanguages,
    selectedInterests,
    selectedRegions,
    audienceCommunityType,
    selectedCommunities,
    audienceIndustryType,
    selectedIndustries,
    selectedRequirements,
    generatedInterests,
  ]);

  // Handle video requirement input
  const handleVideoRequirementKeyPress = (e) => {
    if (e.key === "Enter" && videoInput.trim()) {
      setVideoRequirements([...videoRequirements, videoInput.trim()]);
      setVideoInput("");
    }
  };

  const removeVideoRequirement = (index) => {
    setVideoRequirements(videoRequirements.filter((_, i) => i !== index));
  };

  // Clear all video requirements
  const clearAllVideoRequirements = () => {
    setVideoRequirements([]);
  };

  // Handle template selection
  const addTemplate = (template) => {
    const newRequirements = template.requirements.filter(
      (req) => !videoRequirements.includes(req),
    );
    setVideoRequirements([...videoRequirements, ...newRequirements]);
  };

  // Handle campaign language
  const handleLanguageKeyPress = (e) => {
    if (e.key === "Enter" && campaignLanguageInput.trim()) {
      setSelectedLanguages([
        ...selectedLanguages,
        campaignLanguageInput.trim(),
      ]);
      setCampaignLanguageInput("");
    }
  };

  const removeLanguage = (language) => {
    setSelectedLanguages(selectedLanguages.filter((item) => item !== language));
  };

  // Handle audience interests
  const handleInterestKeyPress = (e) => {
    if (e.key === "Enter" && audienceInterestsInput.trim()) {
      setSelectedInterests([
        ...selectedInterests,
        audienceInterestsInput.trim(),
      ]);
      setAudienceInterestsInput("");
    }
  };

  const generateTags = async () => {
    setTagsLoading(true);
    try {
      // 从sessionStorage读取campaign info
      const saved = sessionStorage.getItem("campaign_info_form");
      if (!saved) throw new Error("Please complete Campaign Info first.");
      const data = JSON.parse(saved);
      if (!data.campaignName || !data.productDescription || !data.landingPage) {
        throw new Error("Please complete Campaign Info fields.");
      }
      const req = {
        campaign_name: data.campaignName,
        product_description: data.productDescription,
        landing_page_url: data.landingPage,
        suggestions: 15,
      };
      const res = await axios.post(
        `${process.env.REACT_APP_API_BASE_URL}/tag-generate`,
        req
      );
      if (Array.isArray(res.data)) {
        setGeneratedInterests(res.data);
        // Automatically add all generated tags to selected interests
        const newInterests = res.data.filter(
          (interest) => !selectedInterests.includes(interest)
        );
        setSelectedInterests([...selectedInterests, ...newInterests]);
      } else {
        throw new Error("Invalid response from tag API");
      }
    } catch (err) {
      alert(err.message || "Failed to generate tags");
    } finally {
      setTagsLoading(false);
    }
  };

  const addInterest = (interest) => {
    if (!selectedInterests.includes(interest)) {
      setSelectedInterests([...selectedInterests, interest]);
    }
  };

  const removeInterest = (interest) => {
    setSelectedInterests(selectedInterests.filter((item) => item !== interest));
  };

  const addAllGeneratedInterests = () => {
    const newInterests = generatedInterests.filter(
      (interest) => !selectedInterests.includes(interest),
    );
    setSelectedInterests([...selectedInterests, ...newInterests]);
  };

  const clearAllInterests = () => {
    setSelectedInterests([]);
  };

  // Handle age group selection
  const toggleAgeGroup = (ageGroup) => {
    setSelectedAgeGroups((prev) =>
      prev.includes(ageGroup)
        ? prev.filter((item) => item !== ageGroup)
        : [...prev, ageGroup],
    );
  };

  // Handle gender selection
  const toggleGender = (gender) => {
    setSelectedGenders((prev) =>
      prev.includes(gender)
        ? prev.filter((item) => item !== gender)
        : [...prev, gender],
    );
  };

  // Handle region search and selection
  const handleRegionInputChange = (e) => {
    const value = e.target.value;
    setAudienceRegionInput(value);
    
    if (value.trim()) {
      const filtered = availableRegions.filter(region => 
        region.name.toLowerCase().includes(value.toLowerCase()) ||
        region.code.toLowerCase().includes(value.toLowerCase()) ||
        region.continent.toLowerCase().includes(value.toLowerCase())
      ).filter(region => !selectedRegions.includes(region.name));
      
      setFilteredRegions(filtered);
      setRegionSearchOpen(true);
    } else {
      setFilteredRegions([]);
      setRegionSearchOpen(false);
    }
  };

  const handleRegionSelect = (region) => {
    if (!selectedRegions.includes(region.name)) {
      setSelectedRegions([...selectedRegions, region.name]);
    }
    setAudienceRegionInput("");
    setFilteredRegions([]);
    setRegionSearchOpen(false);
  };

  const removeRegion = (region) => {
    setSelectedRegions(selectedRegions.filter((item) => item !== region));
  };

  const handleRegionInputFocus = () => {
    if (filteredRegions.length > 0) {
      setRegionSearchOpen(true);
    }
  };

  const handleRegionInputBlur = () => {
    // 延迟关闭，让用户有时间点击选项
    setTimeout(() => setRegionSearchOpen(false), 200);
  };

  // Calculate total population of selected regions
  const calculateTotalPopulation = () => {
    return selectedRegions.reduce((total, regionName) => {
      const region = availableRegions.find(r => r.name === regionName);
      return total + (region ? region.population : 0);
    }, 0);
  };

  // Format population number for display
  const formatPopulation = (population) => {
    if (population >= 1000) {
      return `${(population / 1000).toFixed(1)}B`;
    } else if (population >= 1) {
      return `${population.toFixed(1)}M`;
    } else {
      return `${(population * 1000).toFixed(0)}K`;
    }
  };



  // Handle community input
  const handleCommunityKeyPress = (e) => {
    if (e.key === "Enter" && audienceCommunityInput.trim()) {
      setSelectedCommunities([
        ...selectedCommunities,
        audienceCommunityInput.trim(),
      ]);
      setAudienceCommunityInput("");
    }
  };

  const removeCommunity = (community) => {
    setSelectedCommunities(
      selectedCommunities.filter((item) => item !== community),
    );
  };

  // Handle industry input
  const handleIndustryKeyPress = (e) => {
    if (e.key === "Enter" && audienceIndustryInput.trim()) {
      setSelectedIndustries([
        ...selectedIndustries,
        audienceIndustryInput.trim(),
      ]);
      setAudienceIndustryInput("");
    }
  };

  const removeIndustry = (industry) => {
    setSelectedIndustries(
      selectedIndustries.filter((item) => item !== industry),
    );
  };

  // Handle requirement input
  const handleRequirementKeyPress = (e) => {
    if (e.key === "Enter" && requirementInput.trim()) {
      setSelectedRequirements([
        ...selectedRequirements,
        requirementInput.trim(),
      ]);
      setRequirementInput("");
    }
  };

  const removeRequirement = (requirement) => {
    setSelectedRequirements(
      selectedRequirements.filter((item) => item !== requirement),
    );
  };

  // Clear all requirements
  const clearAllRequirements = () => {
    setSelectedRequirements([]);
  };

  // Handle redline/preference selection
  const addRequirementFromPreset = (requirement) => {
    if (!selectedRequirements.includes(requirement)) {
      setSelectedRequirements([...selectedRequirements, requirement]);
    }
  };

  // 验证必填字段
  const isFormValid = () => {
    // 检查 Campaign Goal
    if (!selectedGoal) return false;

    // 检查 Influencer Selection Priority
    if (!selectedPriority) return false;

    // 检查 Campaign Management
    if (!selectedManagement) return false;

    // 检查 Video Requirements
    if (videoRequirements.length === 0) return false;

    // 检查 Target Audience 部分
    if (selectedLanguages.length === 0) return false;
    if (selectedInterests.length === 0) return false;
    if (selectedRegions.length === 0) return false;

    // 检查 Age Range
    if (ageRangeType === "customized" && selectedAgeGroups.length === 0) return false;

    // 检查 Gender
    if (genderType === "customized" && selectedGenders.length === 0) return false;

    // 检查 Audience Community
    if (audienceCommunityType === "customized" && selectedCommunities.length === 0) return false;

    // 检查 Audience Industry
    if (audienceIndustryType === "customized" && selectedIndustries.length === 0) return false;

    // 检查 Avg Video Impression
    if (avgVideoImpressionType === "custom" && !customAvgVideoImpression) return false;

    // 检查 Follower Range
    if (followerRangeType === "custom" && (!customFollowerMin || !customFollowerMax)) return false;

    return true;
  };

  const handleNext = () => {
    if (onNext) {
      onNext();
    }
  };

  const handleBack = () => {
    if (onBack) {
      onBack();
    }
  };

  return (
    <form className="campaign-form">
      <header className="form-header">
        <div>
          <h2 className="form-title">Audience & Content</h2>
          <p className="form-subtitle">
            Describe your ideal audience and set clear content guidelines
          </p>
        </div>
        <span className="step-indicator">Step 2 of 3</span>
      </header>

      {/* Campaign Goal Section */}
      <section className="form-section">
        <div className="section-title-group">
          <h3 className="section-title">Campaign Goal</h3>
          <p className="section-subtitle">
            Set your campaign objectives and preferred optimization strategy
          </p>
        </div>
        <div className="campaign-goal-options">
          <div
            className={`goal-option ${selectedGoal === "brand-awareness" ? "selected" : ""}`}
            onClick={() => setSelectedGoal("brand-awareness")}
          >
            <div className="goal-icon">📢</div>
            <div className="goal-content">
              <h4 className="goal-title">Brand Awareness</h4>
              <p className="goal-description">
                Focus on maximizing reach and visibility to build brand
                recognition
              </p>
            </div>
            {selectedGoal === "brand-awareness" && (
              <div className="goal-checkmark">✓</div>
            )}
          </div>
          <div
            className={`goal-option ${selectedGoal === "demand-generation" ? "selected" : ""}`}
            onClick={() => setSelectedGoal("demand-generation")}
          >
            <div className="goal-icon">🎯</div>
            <div className="goal-content">
              <h4 className="goal-title">Demand Generation</h4>
              <p className="goal-description">
                Drive purchase intent through engagement
              </p>
            </div>
            {selectedGoal === "demand-generation" && (
              <div className="goal-checkmark">✓</div>
            )}
          </div>
        </div>
      </section>

      {/* Influencer Selection Priority Section */}
      <section className="form-section">
        <div className="section-title-group">
          <h3 className="section-title">Influencer Selection Priority</h3>
          <p className="section-subtitle">
            Choose your primary criteria for influencer selection
          </p>
        </div>
        <div className="priority-options-enhanced">
          <div
            className={`priority-option-enhanced ${selectedPriority === "reach-optimization" ? "selected" : ""}`}
            onClick={() => setSelectedPriority("reach-optimization")}
          >
            <div className="priority-icon">
              <svg
                width="32"
                height="32"
                viewBox="0 0 24 24"
                fill="none"
                xmlns="http://www.w3.org/2000/svg"
              >
                <path
                  d="M3 13c0 4.97 4.03 9 9 9s9-4.03 9-9-4.03-9-9-9-9 4.03-9 9z"
                  stroke="currentColor"
                  strokeWidth="2"
                />
                <path
                  d="m9 9 3 3L22 2"
                  stroke="currentColor"
                  strokeWidth="2"
                  strokeLinecap="round"
                  strokeLinejoin="round"
                />
                <path
                  d="M8 21h8"
                  stroke="currentColor"
                  strokeWidth="2"
                  strokeLinecap="round"
                />
                <path
                  d="M12 17v4"
                  stroke="currentColor"
                  strokeWidth="2"
                  strokeLinecap="round"
                />
              </svg>
            </div>
            <div className="priority-content">
              <h4 className="priority-title">Reach Optimization</h4>
              <p className="priority-description">
                Prioritize creators with high view counts and broad reach
              </p>
            </div>
          </div>
          <div
            className={`priority-option-enhanced ${selectedPriority === "conversion-focus" ? "selected" : ""}`}
            onClick={() => setSelectedPriority("conversion-focus")}
          >
            <div className="priority-icon">
              <svg
                width="32"
                height="32"
                viewBox="0 0 24 24"
                fill="none"
                xmlns="http://www.w3.org/2000/svg"
              >
                <path
                  d="M12 2L2 7v10c0 5.55 3.84 9.74 9 11 5.16-1.26 9-5.46 9-11V7l-10-5z"
                  stroke="currentColor"
                  strokeWidth="2"
                />
                <path
                  d="M9 12l2 2 4-4"
                  stroke="currentColor"
                  strokeWidth="2"
                  strokeLinecap="round"
                  strokeLinejoin="round"
                />
              </svg>
            </div>
            <div className="priority-content">
              <h4 className="priority-title">Conversion Focus</h4>
              <p className="priority-description">
                Select creators with strong sales performance history
              </p>
            </div>
          </div>
          <div
            className={`priority-option-enhanced ${selectedPriority === "audience-targeting" ? "selected" : ""}`}
            onClick={() => setSelectedPriority("audience-targeting")}
          >
            <div className="priority-icon">
              <svg
                width="32"
                height="32"
                viewBox="0 0 24 24"
                fill="none"
                xmlns="http://www.w3.org/2000/svg"
              >
                <circle
                  cx="12"
                  cy="12"
                  r="10"
                  stroke="currentColor"
                  strokeWidth="2"
                />
                <circle
                  cx="12"
                  cy="12"
                  r="6"
                  stroke="currentColor"
                  strokeWidth="2"
                />
                <circle
                  cx="12"
                  cy="12"
                  r="2"
                  stroke="currentColor"
                  strokeWidth="2"
                />
              </svg>
            </div>
            <div className="priority-content">
              <h4 className="priority-title">Audience Targeting</h4>
              <p className="priority-description">
                Focus on creators with highly targeted, relevant audiences
              </p>
            </div>
          </div>
        </div>
      </section>

      {/* Campaign Management Section */}
      <section className="form-section">
        <div className="section-title-group">
          <h3 className="section-title">Campaign Management</h3>
          <p className="section-subtitle">
            Choose how you want your campaign to be managed
          </p>
        </div>
        <div className="management-options">
          <div
            className={`management-option ${selectedManagement === "ai-automation" ? "selected" : ""}`}
            onClick={() => setSelectedManagement("ai-automation")}
          >
            <h4 className="management-title">AI-Powered Automation</h4>
            <p className="management-description">
              Activate full AI automation to intelligently run your campaign,
              continuously optimizing for reach, engagement, and conversions
            </p>
            <div className="management-features">
              <div className="feature-item">✓ Automated optimization</div>
              <div className="feature-item">✓ Smart budget allocation</div>
              <div className="feature-item">
                ✓ Real-time performance tracking
              </div>
              <div className="feature-item">
                ✓ AI-driven performance reports
              </div>
              <div className="feature-item">✓ 24/7 monitoring</div>
            </div>
          </div>
          <div
            className={`management-option ${selectedManagement === "dedicated-service" ? "selected" : ""}`}
            onClick={() => setSelectedManagement("dedicated-service")}
          >
            <h4 className="management-title">Dedicated Service</h4>
            <div className="service-fee">+$500 service fee</div>
            <p className="management-description">
              Your dedicated campaign specialist manages every interaction and
              refines performance at every stage
            </p>
            <div className="management-features">
              <div className="feature-item">✓ Personal campaign manager</div>
              <div className="feature-item">
                ✓ Manual partnership confirmation
              </div>
              <div className="feature-item">✓ Custom optimization strategy</div>
              <div className="feature-item">✓ Direct communication channel</div>
              <div className="feature-item">✓ Priority support</div>
            </div>
          </div>
        </div>
      </section>

      {/* Video Requirement Section - Expandable (No Icon) - 默认展开 */}
      <section className="form-section expandable-section">
        <div
          className="section-header expandable-header"
          onClick={() => setVideoRequirementOpen(!videoRequirementOpen)}
        >
          <div className="section-title-group">
            <h3 className="section-title">Video Requirement</h3>
            <p className="section-subtitle">
              Define your content guidelines and requirements
            </p>
          </div>
          <div className={`expand-arrow ${videoRequirementOpen ? "open" : ""}`}>
            ▼
          </div>
        </div>
        {videoRequirementOpen && (
          <div className="expandable-content">
            <input
              type="text"
              placeholder="Add a video requirement (e.g. product demo, marketing video) - Press Enter to add"
              className="text-input"
              value={videoInput}
              onChange={(e) => setVideoInput(e.target.value)}
              onKeyPress={handleVideoRequirementKeyPress}
            />

            {/* Quick Templates Section */}
            <div className="quick-templates-section">
              <h4 className="templates-title">Quick Templates</h4>
              <p className="templates-subtitle">
                Choose from common video requirement templates
              </p>
              <div className="template-grid">
                {videoTemplates.map((template, index) => (
                  <div
                    key={index}
                    className="template-card clickable"
                    onClick={() => addTemplate(template)}
                  >
                    <div className="template-header">
                      <h5 className="template-name">{template.name}</h5>
                      <p className="template-description">
                        {template.description}
                      </p>
                    </div>
                  </div>
                ))}
              </div>
            </div>

            {videoRequirements.length > 0 && (
              <div className="tags-container-with-clear">
                <div className="tags-container">
                  {videoRequirements.map((requirement, index) => (
                    <div key={index} className="tag-item">
                      <span className="tag-text">{requirement}</span>
                      <button
                        type="button"
                        className="tag-remove"
                        onClick={() => removeVideoRequirement(index)}
                      >
                        ×
                      </button>
                    </div>
                  ))}
                </div>
                <button
                  type="button"
                  className="clear-all-requirements-btn"
                  onClick={clearAllVideoRequirements}
                  title="Clear all video requirements"
                >
                  🗑️
                </button>
              </div>
            )}

            {/* Tips Section */}
            <div className="video-tips-section">
              <h5 className="tips-title">Video Requirement Tips</h5>
              <ul className="tips-list">
                <li>Be specific about what you want to see in the video</li>
                <li>Include technical requirements (length, format, etc.)</li>
                <li>Specify any mandatory elements or shots</li>
                <li>Mention brand guidelines or style preferences</li>
                <li>Add any specific calls-to-action needed</li>
              </ul>
            </div>
          </div>
        )}
      </section>

      {/* Target Audience Section - Expandable */}
      <section className="form-section expandable-section">
        <div
          className="section-header expandable-header"
          onClick={() => setTargetAudienceOpen(!targetAudienceOpen)}
        >
          <div className="section-title-group">
            <h3 className="section-title">Target Audience</h3>
            <p className="section-subtitle">
              Define your ideal audience demographics and interests
            </p>
          </div>
          <div className={`expand-arrow ${targetAudienceOpen ? "open" : ""}`}>
            ▼
          </div>
        </div>
        {targetAudienceOpen && (
          <div className="expandable-content">
            {/* Campaign Language */}
            <div className="form-field">
              <label className="field-label">Campaign Language</label>
              <p className="field-description">
                Select the primary language for your campaign content
              </p>
              <input
                type="text"
                placeholder="Enter languages and press Enter to add (e.g. English, Chinese, Spanish)"
                className="text-input"
                value={campaignLanguageInput}
                onChange={(e) => setCampaignLanguageInput(e.target.value)}
                onKeyPress={handleLanguageKeyPress}
              />
              {selectedLanguages.length > 0 && (
                <div className="tags-container">
                  {selectedLanguages.map((language, index) => (
                    <div key={index} className="tag-item">
                      <span className="tag-text">{language}</span>
                      <button
                        type="button"
                        className="tag-remove"
                        onClick={() => removeLanguage(language)}
                      >
                        ×
                      </button>
                    </div>
                  ))}
                </div>
              )}
            </div>

            {/* Audience Interests */}
            <div className="form-field">
              <label className="field-label">Audience Interests</label>
              <p className="field-description">
                Define interest tags for your target audience
              </p>
              <div className="interests-input-container">
                <input
                  type="text"
                  placeholder="Enter interests and press Enter to add, or use AI generation"
                  className="text-input"
                  value={audienceInterestsInput}
                  onChange={(e) => setAudienceInterestsInput(e.target.value)}
                  onKeyPress={handleInterestKeyPress}
                />
                <div className="interests-buttons">
                  <button
                    type="button"
                    className="interest-btn generate-btn"
                    onClick={generateTags}
                    disabled={tagsLoading}
                  >
                    {tagsLoading ? "Generating..." : "Generate Tags"}
                  </button>
                  <button
                    type="button"
                    className="interest-btn add-all-btn"
                    onClick={addAllGeneratedInterests}
                  >
                    Add All
                  </button>
                  <button
                    type="button"
                    className="interest-btn delete-all-btn"
                    onClick={clearAllInterests}
                  >
                    Remove All
                  </button>
                </div>
              </div>

              {/* Generated Interests */}
              {generatedInterests.length > 0 && (
                <div className="generated-interests">
                  <h5 className="generated-title">AI Generated Suggestions:</h5>
                  <div className="tags-container">
                    {generatedInterests.map((interest, index) => (
                      <div key={index} className="generated-tag-item">
                        <span className="tag-text">{interest}</span>
                        <button
                          type="button"
                          className="tag-add"
                          onClick={() => addInterest(interest)}
                          disabled={selectedInterests.includes(interest)}
                        >
                          +
                        </button>
                      </div>
                    ))}
                  </div>
                </div>
              )}

              {/* Selected Interests */}
              {selectedInterests.length > 0 && (
                <div className="selected-interests">
                  <h5 className="selected-title">Selected Interests:</h5>
                  <div className="tags-container">
                    {selectedInterests.map((interest, index) => (
                      <div key={index} className="tag-item selected">
                        <span className="tag-text">{interest}</span>
                        <button
                          type="button"
                          className="tag-remove"
                          onClick={() => removeInterest(interest)}
                        >
                          ×
                        </button>
                      </div>
                    ))}
                  </div>
                </div>
              )}
            </div>

            {/* Age Range and Gender */}
            <div className="demographic-section">
              <div className="demographic-field">
                <label className="field-label">Age Range</label>
                <div className="demographic-options">
                  <div
                    className={`demographic-option ${ageRangeType === "ai-optimized" ? "selected" : ""}`}
                    onClick={() => setAgeRangeType("ai-optimized")}
                  >
                    <div className="option-radio"></div>
                    <span className="option-label">AI Optimized</span>
                  </div>
                  <div
                    className={`demographic-option ${ageRangeType === "customized" ? "selected" : ""}`}
                    onClick={() => setAgeRangeType("customized")}
                  >
                    <div className="option-radio"></div>
                    <span className="option-label">Customized Value</span>
                  </div>
                </div>
                {ageRangeType === "customized" && (
                  <div className="custom-select-container">
                    <div className="multi-select-dropdown">
                      <div className="dropdown-header">Select Age Groups</div>
                      <div className="dropdown-options">
                        {ageGroupOptions.map((ageGroup) => (
                          <div
                            key={ageGroup}
                            className={`dropdown-option ${selectedAgeGroups.includes(ageGroup) ? "selected" : ""}`}
                            onClick={() => toggleAgeGroup(ageGroup)}
                          >
                            <div className="option-checkbox"></div>
                            <span>{ageGroup}</span>
                          </div>
                        ))}
                      </div>
                      {selectedAgeGroups.length > 0 && (
                        <div className="selected-values">
                          {selectedAgeGroups.map((ageGroup) => (
                            <div key={ageGroup} className="selected-value-tag">
                              <span>{ageGroup}</span>
                              <button
                                type="button"
                                className="tag-remove"
                                onClick={() => toggleAgeGroup(ageGroup)}
                              >
                                ×
                              </button>
                            </div>
                          ))}
                        </div>
                      )}
                    </div>
                  </div>
                )}
              </div>

              <div className="demographic-field">
                <label className="field-label">Gender</label>
                <div className="demographic-options">
                  <div
                    className={`demographic-option ${genderType === "ai-optimized" ? "selected" : ""}`}
                    onClick={() => setGenderType("ai-optimized")}
                  >
                    <div className="option-radio"></div>
                    <span className="option-label">AI Optimized</span>
                  </div>
                  <div
                    className={`demographic-option ${genderType === "customized" ? "selected" : ""}`}
                    onClick={() => setGenderType("customized")}
                  >
                    <div className="option-radio"></div>
                    <span className="option-label">Customized Value</span>
                  </div>
                </div>
                {genderType === "customized" && (
                  <div className="custom-select-container">
                    <div className="multi-select-dropdown">
                      <div className="dropdown-header">Select Gender</div>
                      <div className="dropdown-options">
                        {genderOptions.map((gender) => (
                          <div
                            key={gender}
                            className={`dropdown-option ${selectedGenders.includes(gender) ? "selected" : ""}`}
                            onClick={() => toggleGender(gender)}
                          >
                            <div className="option-checkbox"></div>
                            <span>{gender}</span>
                          </div>
                        ))}
                      </div>
                      {selectedGenders.length > 0 && (
                        <div className="selected-values">
                          {selectedGenders.map((gender) => (
                            <div key={gender} className="selected-value-tag">
                              <span>{gender}</span>
                              <button
                                type="button"
                                className="tag-remove"
                                onClick={() => toggleGender(gender)}
                              >
                                ×
                              </button>
                            </div>
                          ))}
                        </div>
                      )}
                    </div>
                  </div>
                )}
              </div>
            </div>

            {/* Audience Region */}
            <div className="form-field">
              <label className="field-label">Audience Region</label>
              <p className="field-description">
                Search and select target geographical regions
              </p>
              <div className="region-search-container" style={{ position: 'relative' }}>
                <input
                  type="text"
                  placeholder="Search countries, regions, or codes (e.g. United States, US, Europe)"
                  className="text-input"
                  value={audienceRegionInput}
                  onChange={handleRegionInputChange}
                  onFocus={handleRegionInputFocus}
                  onBlur={handleRegionInputBlur}
                />
                {regionSearchOpen && filteredRegions.length > 0 && (
                  <div className="region-dropdown" style={{
                    position: 'absolute',
                    top: '100%',
                    left: 0,
                    right: 0,
                    background: 'white',
                    border: '1px solid #e1e5e9',
                    borderRadius: '8px',
                    boxShadow: '0 4px 6px rgba(0, 0, 0, 0.1)',
                    maxHeight: '200px',
                    overflowY: 'auto',
                    zIndex: 1000
                  }}>
                    {filteredRegions.map((region, index) => (
                      <div
                        key={index}
                        className="region-option"
                        style={{
                          padding: '12px 16px',
                          cursor: 'pointer',
                          borderBottom: index < filteredRegions.length - 1 ? '1px solid #f0f0f0' : 'none',
                          display: 'flex',
                          justifyContent: 'space-between',
                          alignItems: 'center'
                        }}
                        onClick={() => handleRegionSelect(region)}
                        onMouseEnter={(e) => e.target.style.backgroundColor = '#f8f9fa'}
                        onMouseLeave={(e) => e.target.style.backgroundColor = 'white'}
                      >
                        <div>
                          <div style={{ fontWeight: '500', color: '#333' }}>{region.name}</div>
                          <div style={{ fontSize: '12px', color: '#666' }}>
                            {region.continent} • {formatPopulation(region.population)} people
                          </div>
                        </div>
                        <div style={{ 
                          fontSize: '12px', 
                          color: '#999',
                          fontFamily: 'monospace',
                          backgroundColor: '#f0f0f0',
                          padding: '2px 6px',
                          borderRadius: '4px'
                        }}>
                          {region.code}
                        </div>
                      </div>
                    ))}
                  </div>
                )}
              </div>
              {selectedRegions.length > 0 && (
                <>
                  <div className="tags-container">
                    {selectedRegions.map((region, index) => (
                      <div key={index} className="tag-item">
                        <span className="tag-text">{region}</span>
                        <button
                          type="button"
                          className="tag-remove"
                          onClick={() => removeRegion(region)}
                        >
                          ×
                        </button>
                      </div>
                    ))}
                  </div>
                  
                  {/* Audience Population Display */}
                  <div className="audience-population-module" style={{
                    marginTop: '16px',
                    padding: '16px',
                    backgroundColor: '#f8f9fa',
                    border: '1px solid #e9ecef',
                    borderRadius: '8px',
                    display: 'flex',
                    alignItems: 'center',
                    gap: '12px'
                  }}>
                    <div style={{
                      width: '40px',
                      height: '40px',
                      backgroundColor: '#007bff',
                      borderRadius: '50%',
                      display: 'flex',
                      alignItems: 'center',
                      justifyContent: 'center',
                      flexShrink: 0
                    }}>
                      <svg width="20" height="20" viewBox="0 0 24 24" fill="white">
                        <path d="M16 4c0-1.11.89-2 2-2s2 .89 2 2-.89 2-2 2-2-.89-2-2zm4 18v-6h2.5l-2.54-7.63A1.5 1.5 0 0 0 18.5 7h-5c-.8 0-1.42.65-1.42 1.45v9.55h2v6h4zm-12.5 0v-6h2.5l-2.54-7.63A1.5 1.5 0 0 0 6 7H1c-.8 0-1.42.65-1.42 1.45v9.55h2v6h4zm4.5-10c0-1.11.89-2 2-2s2 .89 2 2-.89 2-2 2-2-.89-2-2z"/>
                      </svg>
                    </div>
                    <div style={{ flex: 1 }}>
                      <div style={{ 
                        fontSize: '14px', 
                        fontWeight: '600', 
                        color: '#333',
                        marginBottom: '4px'
                      }}>
                        Audience Population
                      </div>
                      <div style={{ 
                        fontSize: '24px', 
                        fontWeight: '700', 
                        color: '#007bff',
                        lineHeight: '1'
                      }}>
                        {formatPopulation(calculateTotalPopulation())}
                      </div>
                      <div style={{ 
                        fontSize: '12px', 
                        color: '#666',
                        marginTop: '2px'
                      }}>
                        Total population across {selectedRegions.length} region{selectedRegions.length > 1 ? 's' : ''}
                      </div>
                    </div>
                    <div style={{
                      fontSize: '12px',
                      color: '#999',
                      textAlign: 'right',
                      lineHeight: '1.4'
                    }}>
                      <div>📊 Data updated</div>
                      <div>for 2024</div>
                    </div>
                  </div>
                </>
              )}
            </div>

            {/* Audience Community */}
            <div className="form-field">
              <label className="field-label">Audience Community</label>
              <div className="community-type-options">
                <div
                  className={`community-option ${audienceCommunityType === "ai-optimized" ? "selected" : ""}`}
                  onClick={() => setAudienceCommunityType("ai-optimized")}
                >
                  <div className="option-radio"></div>
                  <span className="option-label">AI Optimized</span>
                </div>
                <div
                  className={`community-option ${audienceCommunityType === "customized" ? "selected" : ""}`}
                  onClick={() => setAudienceCommunityType("customized")}
                >
                  <div className="option-radio"></div>
                  <span className="option-label">Customized Communities</span>
                </div>
              </div>
              {audienceCommunityType === "customized" && (
                <>
                  <input
                    type="text"
                    placeholder="Enter communities and press Enter to add (e.g. Gaming Community, Fitness Enthusiasts)"
                    className="text-input"
                    value={audienceCommunityInput}
                    onChange={(e) => setAudienceCommunityInput(e.target.value)}
                    onKeyPress={handleCommunityKeyPress}
                  />
                  {selectedCommunities.length > 0 && (
                    <div className="tags-container">
                      {selectedCommunities.map((community, index) => (
                        <div key={index} className="tag-item">
                          <span className="tag-text">{community}</span>
                          <button
                            type="button"
                            className="tag-remove"
                            onClick={() => removeCommunity(community)}
                          >
                            ×
                          </button>
                        </div>
                      ))}
                    </div>
                  )}
                </>
              )}
            </div>

            {/* Audience Industry */}
            <div className="form-field">
              <label className="field-label">Audience Industry</label>
              <div className="industry-type-options">
                <div
                  className={`industry-option ${audienceIndustryType === "ai-optimized" ? "selected" : ""}`}
                  onClick={() => setAudienceIndustryType("ai-optimized")}
                >
                  <div className="option-radio"></div>
                  <span className="option-label">AI Optimized</span>
                </div>
                <div
                  className={`industry-option ${audienceIndustryType === "customized" ? "selected" : ""}`}
                  onClick={() => setAudienceIndustryType("customized")}
                >
                  <div className="option-radio"></div>
                  <span className="option-label">Customized Industries</span>
                </div>
              </div>
              {audienceIndustryType === "customized" && (
                <>
                  <input
                    type="text"
                    placeholder="Enter industries and press Enter to add (e.g. Technology, Fashion)"
                    className="text-input"
                    value={audienceIndustryInput}
                    onChange={(e) => setAudienceIndustryInput(e.target.value)}
                    onKeyPress={handleIndustryKeyPress}
                  />
                  {selectedIndustries.length > 0 && (
                    <div className="tags-container">
                      {selectedIndustries.map((industry, index) => (
                        <div key={index} className="tag-item">
                          <span className="tag-text">{industry}</span>
                          <button
                            type="button"
                            className="tag-remove"
                            onClick={() => removeIndustry(industry)}
                          >
                            ×
                          </button>
                        </div>
                      ))}
                    </div>
                  )}
                </>
              )}
            </div>
          </div>
        )}
      </section>

      {/* Influencer Filters Section */}
      <section className="form-section">
        <div className="section-title-group">
          <h3 className="section-title">Influencer Filters</h3>
          <p className="section-subtitle">
            Fine-tune your campaign's creator requirements
          </p>
        </div>

        <div className="filter-options-row">
          <div className="filter-field">
            <label className="field-label">Minimum Avg Video Impression</label>
            <p className="field-description">
              Set the minimum average video impression requirement for creators
            </p>
            <div className="filter-option-group">
              <div
                className={`filter-option ${avgVideoImpressionType === "ai-optimized" ? "selected" : ""}`}
                onClick={() => setAvgVideoImpressionType("ai-optimized")}
              >
                <h4 className="filter-option-title">Use AI Optimized Minimum Impression</h4>
                <p className="filter-option-description">
                  Automatically adjusted based on your budget and goals
                </p>
              </div>
              <div
                className={`filter-option ${avgVideoImpressionType === "custom" ? "selected" : ""}`}
                onClick={() => setAvgVideoImpressionType("custom")}
              >
                <h4 className="filter-option-title">Set Custom Minimum Impression</h4>
                {avgVideoImpressionType === "custom" && (
                  <input
                    type="text"
                    placeholder="Enter minimum impression number (e.g. 10000)"
                    className="text-input custom-input"
                    value={customAvgVideoImpression}
                    onChange={handleAvgVideoImpressionChange}
                  />
                )}
              </div>
            </div>
          </div>

          <div className="filter-field">
            <label className="field-label">Follower Range</label>
            <p className="field-description">
              Set the follower count range for creators
            </p>
            <div className="filter-option-group">
              <div
                className={`filter-option ${followerRangeType === "ai-optimized" ? "selected" : ""}`}
                onClick={() => setFollowerRangeType("ai-optimized")}
              >
                <h4 className="filter-option-title">Use AI Optimized Range</h4>
                <p className="filter-option-description">
                  Optimized based on your campaign goals and budget
                </p>
              </div>
              <div
                className={`filter-option ${followerRangeType === "custom" ? "selected" : ""}`}
                onClick={() => setFollowerRangeType("custom")}
              >
                <h4 className="filter-option-title">Set Custom Range</h4>
                {followerRangeType === "custom" && (
                  <div className="custom-range-inputs">
                    <input
                      type="text"
                      placeholder="Minimum (e.g. 1000)"
                      className="text-input custom-input range-input"
                      value={customFollowerMin}
                      onChange={handleFollowerMinChange}
                    />
                    <span className="range-separator">to</span>
                    <input
                      type="text"
                      placeholder="Maximum (e.g. 100000)"
                      className="text-input custom-input range-input"
                      value={customFollowerMax}
                      onChange={handleFollowerMaxChange}
                    />
                  </div>
                )}
              </div>
            </div>
          </div>
        </div>

        <div className="form-field">
          <label className="field-label">Additional Requirements</label>
          <input
            type="text"
            placeholder="Add requirement for the ideal influencers profile - Press Enter to add"
            className="text-input"
            value={requirementInput}
            onChange={(e) => setRequirementInput(e.target.value)}
            onKeyPress={handleRequirementKeyPress}
          />
          {selectedRequirements.length > 0 && (
            <div className="tags-container-with-clear">
              <div className="tags-container">
                {selectedRequirements.map((requirement, index) => (
                  <div key={index} className="tag-item">
                    <span className="tag-text">{requirement}</span>
                    <button
                      type="button"
                      className="tag-remove"
                      onClick={() => removeRequirement(requirement)}
                    >
                      ×
                    </button>
                  </div>
                ))}
              </div>
              <button
                type="button"
                className="clear-all-requirements-btn"
                onClick={clearAllRequirements}
                title="Clear all requirements"
              >
                🗑️
              </button>
            </div>
          )}
        </div>

        {/* Redlines/Blacklists Section */}
        <div className="preset-requirements-section">
          <div className="preset-section">
            <div className="preset-header redlines-header">
              <div className="preset-icon redlines-icon">✕</div>
              <h4 className="preset-title redlines-title">
                Redlines/Blacklists
              </h4>
            </div>
            <div className="preset-options">
              {redlineOptions.map((option, index) => (
                <div
                  key={index}
                  className={`preset-option redlines-option ${selectedRequirements.includes(option) ? "selected" : ""}`}
                  onClick={() => addRequirementFromPreset(option)}
                >
                  {option}
                </div>
              ))}
            </div>
          </div>

          <div className="preset-section">
            <div className="preset-header preferences-header">
              <div className="preset-icon preferences-icon">✓</div>
              <h4 className="preset-title preferences-title">
                Creator Preferences
              </h4>
            </div>
            <div className="preset-options">
              {preferencesOptions.map((option, index) => (
                <div
                  key={index}
                  className={`preset-option preferences-option ${selectedRequirements.includes(option) ? "selected" : ""}`}
                  onClick={() => addRequirementFromPreset(option)}
                >
                  {option}
                </div>
              ))}
            </div>
          </div>
        </div>
      </section>

      {/* Navigation Buttons */}
      <div className="form-actions">
        <button type="button" className="back-button" onClick={handleBack}>
          Back
        </button>
        <button 
          type="button" 
          className="next-button" 
          onClick={handleNext}
          disabled={!isFormValid()}
          style={{ 
            opacity: isFormValid() ? 1 : 0.5,
            cursor: isFormValid() ? 'pointer' : 'not-allowed'
          }}
        >
          Next
        </button>
      </div>
    </form>
  );
};

export default AudienceContent;
